module.exports = __webpack_public_path__ + "img/ic_users_active.63e015f1.png";